module.exports = __webpack_public_path__ + "static/media/logo.f8bda7d1.png";